import { useMemo, useState } from "react";
import { CalcSlider, CalcDonut, StatPill, fmtINR } from "./CalcShared";
import { CALC } from "@/constants/testIds";

function fvSIP(monthly, years, ratePct) {
  const r = ratePct / 12 / 100;
  const n = years * 12;
  if (r === 0) return monthly * n;
  return monthly * (((Math.pow(1 + r, n) - 1) / r) * (1 + r));
}

export default function SIPCalculator() {
  const [monthly, setMonthly] = useState(10000);
  const [years, setYears] = useState(15);
  const [rate, setRate] = useState(12);

  const result = useMemo(() => {
    const invested = monthly * years * 12;
    const future = Math.round(fvSIP(monthly, years, rate));
    return { invested, future, gain: future - invested };
  }, [monthly, years, rate]);

  return (
    <div className="grid md:grid-cols-2 gap-8" data-testid={CALC.sipCard}>
      <div className="space-y-6">
        <CalcSlider
          label="Monthly investment"
          value={monthly}
          onChange={setMonthly}
          min={500}
          max={200000}
          step={500}
          format={fmtINR}
          testId={CALC.sipAmount}
        />
        <CalcSlider
          label="Investment period"
          value={years}
          onChange={setYears}
          min={1}
          max={40}
          step={1}
          format={(v) => `${v} yr`}
          testId={CALC.sipYears}
        />
        <CalcSlider
          label="Expected annual return"
          value={rate}
          onChange={setRate}
          min={4}
          max={20}
          step={0.5}
          format={(v) => `${v}%`}
          testId={CALC.sipRate}
        />
      </div>

      <div className="bg-muted/40 rounded-2xl p-6">
        <CalcDonut invested={result.invested} returns={result.gain} />
        <div className="grid grid-cols-3 gap-3 mt-4" data-testid={CALC.sipResult}>
          <StatPill label="Invested" value={fmtINR(result.invested)} />
          <StatPill label="Returns" value={fmtINR(result.gain)} tone="secondary" />
          <StatPill label="Future Value" value={fmtINR(result.future)} tone="primary" />
        </div>
      </div>
    </div>
  );
}
